/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {useLocation} from "react-router";
import {NavLink} from "react-router-dom";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl, checkIsActive} from "../../../../_helpers";
import {routes} from '../../../../../utils/routes';

export function AsideMenuList({layoutProps}) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {routes.map((route) => {
          if (route.children) {
            return (
              <li
                key={route.url}
                className={`menu-item menu-item-submenu ${getMenuItemActive(route.url, true)}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to={route.url}>
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl(route.icon)}/>
                  </span>
                  <span className="menu-text">{route.label}</span>
                  <i className="menu-arrow"/>
                </NavLink>
                <div className="menu-submenu ">
                  <ul className="menu-subnav">
                    <ul className="menu-subnav">
                      <li className="menu-item  menu-item-parent" aria-haspopup="true">
                        <span className="menu-link">
                          <span className="menu-text">{route.label}</span>
                        </span>
                      </li>
                      {route.children.map(child => (
                        <li
                          key={child.url}
                          className={`menu-item ${getMenuItemActive(child.url)}`}
                          aria-haspopup="true"
                        >
                          <NavLink className="menu-link" to={child.url}>
                            <i className="menu-bullet menu-bullet-dot"><span/></i>
                            <span className="menu-text">{child.label}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </ul>
                </div>
              </li>
            )
          } else if (!route.hidden) {
            return (
              <li
                key={route.url}
                className={`menu-item ${getMenuItemActive(route.url, false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to={route.url}>
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl(route.icon)}/>
                  </span>
                  <span className="menu-text">{route.label}</span>
                </NavLink>
              </li>
            )
          } else {
            return null;
          }
        })}
      </ul>
    </>
  );
}
